import { usePlaybackPlay } from '@app/core/playback/hooks/usePlayback';
import { useCallback } from 'react';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';
import { useSetCursor } from '../../stores/stream-screen.store';

export function useSetCursorAndPlay() {
  const setCursor = useSetCursor();
  const play = usePlaybackPlay();
  const playOnCursorSet = useStreamSettingsStore((state) => state.playOnCursorSet);

  return useCallback(
    (ts: number) => {
      setCursor(ts);

      if (playOnCursorSet) {
        play({
          startTs: ts,
        });
      }
    },
    [setCursor, play, playOnCursorSet],
  );
}
